"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkspaceUserWatcherMapDispatch = void 0;
var WorkspaceUserWatcherMapDispatch = function (dispatch, props) {
    return {
        onNext: function (querySnapshot) {
            var item = querySnapshot.data();
            if (item) {
                dispatch({
                    type: 'GET_WORKSPACE_USER_SUCCESS',
                    description: 'WorkspaceUserWatcherMapDispatch',
                    requestValues: {
                        userId: props.userId,
                        workspaceId: props.workspaceId,
                    },
                    successValues: {
                        item: item,
                    },
                });
            }
        },
    };
};
exports.WorkspaceUserWatcherMapDispatch = WorkspaceUserWatcherMapDispatch;
